import React from 'react';

import CountDown from '../../../CountDown';

import '../../../../css/components/batches/CardHeader.css';

const CardHeader = ({
    src,
    title,
    date,
    onFinishDate,
    disabled,
    serverTime,
}) => {
    return (
        <header className="c-card__header u-p-none">
            <p className="u-h5 c-card__title u-mb">{title}</p>
            <div
                className={`bronson-range u-mb ${
                    disabled ? 'c-card--inactive' : ''
                }`}
            >
                <img src={src} sizes="100vw" alt="Imagen coche" />
                {date && (
                    <div
                        className={`c-counter-container u-m-small u-ph-small u-pv-xxsmall u-text-fs-1 ${
                            disabled
                                ? 'u-text-white u-bg-black'
                                : 'u-text-brand'
                        }`}
                    >
                        <CountDown
                            dateTime={date}
                            isFinishedParent={onFinishDate}
                            serverTime={serverTime}
                        />
                    </div>
                )}
            </div>
        </header>
    );
};

export default CardHeader;
